import React from 'react';
import {
  Container,
  Heading,
  Stack,
  Text,
} from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { Page } from 'ui/components/Page';
import { PageHead } from 'ui/components/PageHead';
import { OrderLookUp } from 'ui/forms/OrderLookUp';

const ReturnsPage = () => {
  const t = useTranslate();

  return (
    <Page>
      <PageHead title={t('pageTitle', { title: t('checkOrder') })} />
      <Container size="lg" dataTestId="returns-form">
        <Heading asChild size={{ _: 'xl', md: '3xl' }} weight="bold">
          <h1>{t('returnsFormHeader')}</h1>
        </Heading>
        <Container size="sm" className="pt-16">
          <Stack>
            <Stack gapY="sm">
              <Heading asChild weight="bold">
                <h1>{t('returnsFormTitle')}</h1>
              </Heading>
              <Text asChild>
                <p>{t('returnsFormSubtitle')}</p>
              </Text>
            </Stack>
            <OrderLookUp />
          </Stack>
        </Container>
      </Container>
    </Page>
  );
};

export default ReturnsPage;
